import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Tierart } from '../../../../../administration/tierarten/tierart';

@Component({
    selector: 'kiene-tierart-sonstige-dialog',
    templateUrl: './tierart-sonstige-dialog.component.html',
    styleUrls: ['./tierart-sonstige-dialog.component.scss'],
})
export class TierartSonstigeDialogComponent implements OnInit {
    isSaving = false;
    tierartCtrl: FormControl = new FormControl();

    constructor(
        public dialogRef: MatDialogRef<TierartSonstigeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public tierart: Tierart,
    ) {}

    ngOnInit(): void {
        this.tierartCtrl.setValue(this.tierart);
        this.tierartCtrl.markAsPristine();
    }

    save() {
        this.isSaving = true;
    }
}
